import React from "react";
import './contracting-registration-data.view.css'
import { useTranslation } from "react-i18next";
import {
    Button,
    InputsFormPure,
    TooltipFormPure,
    DescriptionTemplatePure,
    ButtonHLPure,
    Label,
    DropDownBtnHLPure,
    TextAreaHLPure,
    InputHLPure,
    SimpleLoading,
    DialogSystemGLPure,
} from "../../pures";
import { Grid } from "@material-ui/core";
import { useState, useEffect } from "react";
import { ContractorService } from "../../../services";
import { countriesList } from "../../../utils";
import { useHistory } from "react-router-dom";
import { RegistrationValidator } from "../../../validators";


const ContractingRegistrationDataView = (props) => {
    const { t } = useTranslation();
    const validations = RegistrationValidator(t)

    const history = useHistory();

    const { url, step, onHandleBack, onHandleNext, validator, showLoadingRequesting, showCompletedRequesting, showErrorRequesting, toggleLoadingRequesting, toggleCompletedRequesting, toggleErrorRequesting, user, token, idContractor, setTypePersonId, setContractWorkFlow, personTypes } = props;
    const { next, back } = step;
    const [rfc, setRfc] = useState('')
    const [errorRfc, setErrorRfc] = useState(false)
    const [typePerson, setTypePerson] = useState(Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID))
    const [businessName, setBussinessName] = useState('')
    const [errorBusinessName, setErrorBusinessName] = useState(false)
    const [address, setAddress] = useState('')
    const [errorAddress, setErrorAddress] = useState(false)
    const [city, setCity] = useState('')
    const [errorCity, setErrorCity] = useState(false)
    const [stateCity, setStateCity] = useState('')
    const [errorState, setErrorState] = useState(false)
    const [cp, setCp] = useState('')
    const [errorCp, setErrorCp] = useState(false)
    const [name, setName] = useState('')
    const [errorName, setErrorName] = useState(false)
    const [curp, setCurp] = useState(false)
    const [errorCurp, setErrorCurp] = useState(false)
    const [comboPerson, setComboPerson] = useState([])
    const [countrySelected, setCountrySelected] = useState('México')
    const [contractorInfo, setContractorInfo] = useState({})
    const [message, setMessage] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [valueDropCountry, setValueDropCountry] = useState('México')
    const [tipePersonValue, setTipePersonValue] = useState('')
    const [changeTypePerson, setChangeTypeperson] = useState(0)

    useEffect(() => {
        if (!changeTypePerson || changeTypePerson === 0) return
        if (typePerson === Number(process.env.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID) || typePerson === Number(process.env.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_ID)) {
            setName(businessName)
        } else {
            setBussinessName(name)
        }
    }, [changeTypePerson])

    const handleDropDownChangePerson = (e) => {
        setTypePerson(Number(e.target.value))
        setTypePersonId(Number(e.target.value))
        setChangeTypeperson(Number(e.target.value))
    }

    const onChangeBussinessName = (e) => {
        setBussinessName(e.target.value)
        setErrorBusinessName(false)
    }

    const onChangeAddress = (e) => {
        setAddress(e.target.value)
        setErrorAddress(false)
    }

    const onChangeRfc = (e) => {
        setErrorRfc(false)
        setRfc(e.target.value)
    }

    const onChangeCity = (e) => {
        setCity(e.target.value)
        setErrorCity(false)
    }

    const onChangeState = (e) => {
        setStateCity(e.target.value)
        setErrorState(false)
    }

    const onChangeCP = (e) => {
        setCp(e.target.value)
        setErrorCp(false)
    }

    const onChangeName = (e) => {
        setName(e.target.value)
        setErrorName(false)
    }

    const onChangeCurp = (e) => {
        setCurp(e.target.value)
        setErrorCurp(false)
    }

    const handleDropDownChageCountries = (e) => {
        setCountrySelected(e.target.value)
    }


    //get contractor
    const getContractor = async () => {
        setIsLoading(true)
        let ENV = process.env
        try {
            let contractorService = new ContractorService(url)
            let contractor = await contractorService.getContarctorByEmailAndClientId(idContractor, token)
            if (contractor && contractor.contractor.contractorTypeId) {
                let country = contractor && contractor.contractor && contractor.contractor.contractorCountry ? contractor.contractor.contractorCountry : 'México'
                let copyTypePerson = [...personTypes]
                let comboPersons = []
                comboPersons.push(copyTypePerson.find((type) => type.id === contractor.contractor.contractorTypeId))
                setValueDropCountry(country)
                setTipePersonValue(contractor.contractor.contractorTypeId)
                setComboPerson(comboPersons)
                setTypePerson(contractor.contractor.contractorTypeId)
                setBussinessName(contractor.contractor.name)
                setRfc(contractor.contractor.rfc)
                setName(contractor.contractor.name)
                setCurp(contractor.contractor.curp)
                setAddress(contractor.contractor.contractorStreet)
                setCity(contractor.contractor.contractorTownship)
                setStateCity(contractor.contractor.contractorState)
                setCp(contractor.contractor.contractorZipCode)
                setContractorInfo(contractor.contractor)
                setTypePersonId(contractor.contractor.contractorTypeId)
            }

        } catch (error) {
            console.log(error)
        }
        setIsLoading(false)
    }


    useEffect(() => {
        if (!personTypes || personTypes.length === 0) return
        getContractor()
    }, [personTypes])



    //save info contractor
    const handleSaveInfo = async (e) => {
        if (errorRfc || errorBusinessName || errorAddress || errorCity || errorState || errorCp || errorName || errorCp || errorCurp) return

        toggleLoadingRequesting(true)
        let personNumberMoralFisico = 0
        let businessNameMoral = ''
        let RFCMoralFisico = ''
        let nameFisico = ''
        let CURPFisico = ''
        let ENV = process.env

        if (name === '' || businessName === '') {
            toggleLoadingRequesting(false)
            let errorName = (typePerson === Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID) || typePerson === Number(ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_ID)) ? t("contractingRegistrationDataView.add.name") : t("contractingRegistrationDataView.add.businessName")
            setMessage(errorName)
            toggleErrorRequesting(true, 4000)
            return
        }

        //validate bussiness or name
        if (typePerson === Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_PHYSICAL_ID) || typePerson === Number(ENV.REACT_APP_PERSON_TYPE_REPSE_PHYSICAL_ID)) {
            personNumberMoralFisico = typePerson
            nameFisico = name
            RFCMoralFisico = rfc
            CURPFisico = curp
        }


        if (typePerson === Number(ENV.REACT_APP_PERSON_TYPE_CONTRACTOR_MORAL_ID) || typePerson === Number(ENV.REACT_APP_PERSON_TYPE_REPSE_MORAL_ID)) {
            personNumberMoralFisico = typePerson
            nameFisico = businessName
            RFCMoralFisico = rfc
        }


        //set info to send
        let contractorCountry = countrySelected ? countrySelected : 'México'
        let id = contractorInfo.id
        let contractorPersonTypeId = personNumberMoralFisico
        let nameSend = nameFisico
        let rfcSend = RFCMoralFisico
        let curpSend = CURPFisico
        let limitDate = contractorInfo.limitDate
        let notes = contractorInfo.notes
        let contractorStreet = address
        let contractorTownship = city
        let contractorState = stateCity
        let contractorZipCode = cp

        try {
            let contractorService = new ContractorService(url)
            let solicitudId = `${idContractor}`
            let updateContractor = await contractorService.updateContractor(id, contractorPersonTypeId, nameSend, rfcSend, curpSend, limitDate, notes, contractorStreet, contractorTownship, contractorState, contractorZipCode, contractorCountry, solicitudId, token)
            if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 200) {
                let idWorkflow = updateContractor.data.data ? updateContractor.data.data : ''
                setContractWorkFlow(idWorkflow)
                toggleLoadingRequesting(false)
                toggleCompletedRequesting(true)
                setTimeout(() => {
                    toggleCompletedRequesting(false)
                    onHandleNext(e)
                }, 2000)
            } else if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 421) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 4000, t("register.collaborator.firstNameValidator"))
            } else if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 422) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 4000, t("register.collaborator.rfcValidato"))
            } else if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 423) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 4000, t("contractingRegistrationDataView.input.curp.error"))
            } else if (updateContractor && updateContractor.data && updateContractor.data.data && Number(updateContractor.data.statusCode) === 424) {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 4000, t("contractingRegistrationDataView.input.cp.error"))
            } else {
                toggleLoadingRequesting(false)
                toggleErrorRequesting(true, 4000, t("contractingRegistrationDataView.errors.update.general"))
            }
        } catch (error) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(true, 4000, t("contractingRegistrationDataView.errors.update.general"))
        }
    }

    const handleExit = () => {
        history.push("/")
    }

    const handleValidateRFCMoral = () => {
        let validRFCMoral = validations.moralRfcValidator(rfc)
        if (validRFCMoral !== '') {
            setErrorRfc(true)
        }
    }

    const handleValidateRFCFisico = () => {
        if (rfc) {
            let rfcRegex = new RegExp(/^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/)
            let validateRfc = (rfcRegex.test(rfc.toUpperCase())) ? '' : t('registration.validator.rfcValidato')
            if (validateRfc !== '') {
                setErrorRfc(true)
            }
        }
    }

    return (
        <div className="contractingRegistrationDataView-container">
            {
                isLoading ? (
                    <SimpleLoading />
                ) :
                    (
                        <>
                            {showLoadingRequesting ? (<DialogSystemGLPure showLoadingRequesting={showLoadingRequesting} toggleLoadingRequesting={toggleLoadingRequesting} />) : null}
                            {showErrorRequesting ? (<DialogSystemGLPure showErrorRequesting={showErrorRequesting} toggleErrorRequesting={toggleErrorRequesting} message={message} />) : null}
                            {showCompletedRequesting ? (<DialogSystemGLPure showCompletedRequesting={showCompletedRequesting} toggleCompletedRequesting={toggleCompletedRequesting} />) : null}

                            <Grid container lg={12} md={12} sm={12} xs={12}>
                                <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    className="contractingRegistrationDataView-container-inputs"
                                >
                                    <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={12}
                                        xs={12}
                                        className=""
                                    >
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <Label title={t('contractingRegistrationDataView.label.title.general.data')} />
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <DropDownBtnHLPure
                                                labelDropDown={t('contractingRegistrationDataView.dropdown.label.type.person')}
                                                optionsDropDown={comboPerson}
                                                disable
                                                onDropDownChange={(e) => handleDropDownChangePerson(e)}
                                                optionsValue={tipePersonValue}
                                                valueItem={"id"}
                                                nameOption={"name"}
                                            />
                                        </div>
                                        {
                                            typePerson === 8 || typePerson === 10
                                                ? <>
                                                    <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                                        <InputHLPure
                                                            typeInput="text"
                                                            labelInput={t('contractingRegistrationDataView.input.label.bussiness.name') + " *"}
                                                            valueInput={businessName}
                                                            handleChangeInput={(e) => onChangeBussinessName(e)}
                                                            tooltipShow
                                                            positionTooltip={'right'}
                                                            titleTooltip={t('contractingRegistrationDataView.input.label.bussiness.name')}
                                                            descriptionTooltip={t('contractingRegistrationDataView.input.bussiness.name.tooltip.description')}
                                                            subContent={''}
                                                            informationIcon={true}
                                                            inputActive={true}
                                                        />
                                                        {errorBusinessName && (
                                                            <span className="hint-message-error">
                                                                {t('contractingRegistrationDataView.input.bussiness.name.error')}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <InputHLPure
                                                        typeInput="text"
                                                        labelInput={
                                                            t("taxDataInvoaInvoicingView.rfc")
                                                        }
                                                        valueInput={rfc}
                                                        handleChangeInput={(e) => onChangeRfc(e)}
                                                        tooltipShow={false}
                                                        informationIcon={false}
                                                        inputActive={true}
                                                        onBlur={handleValidateRFCMoral}
                                                    />
                                                    {errorRfc && (
                                                        <span className="hint-message-error">
                                                            {t("taxDataInvoincingValidator.errorRFC.moral")}
                                                        </span>
                                                    )}
                                                </>
                                                : <>
                                                    <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                                        <InputHLPure
                                                            typeInput="text"
                                                            labelInput={t('contractingRegistrationDataView.input.name.label') + " *"}
                                                            valueInput={name}
                                                            handleChangeInput={(e) => onChangeName(e)}
                                                            tooltipShow
                                                            positionTooltip={'right'}
                                                            titleTooltip={t('contractingRegistrationDataView.input.name.label')}
                                                            descriptionTooltip={t('contractingRegistrationDataView.input.name.tooltip.description')}
                                                            subContent={''}
                                                            informationIcon={true}
                                                            inputActive={true}
                                                        />
                                                        {errorName && (
                                                            <span className="hint-message-error">
                                                                {t('contractingRegistrationDataView.input.name.error')}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                                        <InputHLPure
                                                            typeInput="text"
                                                            labelInput={
                                                                t("taxDataInvoaInvoicingView.rfc")
                                                            }
                                                            valueInput={rfc}
                                                            handleChangeInput={(e) => onChangeRfc(e)}
                                                            tooltipShow={false}
                                                            informationIcon={false}
                                                            inputActive={true}
                                                            onBlur={handleValidateRFCFisico}

                                                        />
                                                        {errorRfc && (
                                                            <span className="hint-message-error">
                                                                {t("taxDataInvoincingValidator.errorRFC.fisico")}
                                                            </span>
                                                        )}
                                                    </div>
                                                    <InputHLPure
                                                        typeInput="text"
                                                        labelInput={t("registrationFreelanceDataView.curp")}
                                                        valueInput={curp}
                                                        handleChangeInput={(e) => onChangeCurp(e)}
                                                        tooltipShow={false}
                                                        informationIcon={false}
                                                        inputActive={true}
                                                    />
                                                    {errorCurp && (
                                                        <span className="hint-message-error">
                                                            {t('contractingRegistrationDataView.input.curp.error')}
                                                        </span>
                                                    )}
                                                </>

                                        }
                                    </Grid>
                                    <Grid
                                        item
                                        lg={6}
                                        md={6}
                                        sm={12}
                                        xs={12}
                                        className="contractingRegistrationDataView-container-right"
                                    >
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <Label title={t('contractingRegistrationDataView.label.title.addrress')} />
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <TextAreaHLPure
                                                labelTextArea={t('contractingRegistrationDataView.text.area.address.label')}
                                                valueTextData={address}
                                                handleChangeTextArea={(e) => onChangeAddress(e)}
                                            />
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <InputHLPure
                                                typeInput="text"
                                                labelInput={t('contractingRegistrationDataView.input.city.label')}
                                                valueInput={city}
                                                handleChangeInput={(e) => onChangeCity(e)}
                                                tooltipShow={false}
                                                informationIcon={false}
                                                inputActive={true}
                                            />
                                            {errorCity && (
                                                <span className="hint-message-error">
                                                    {t('contractingRegistrationDataView.input.city.error')}
                                                </span>
                                            )}
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <InputHLPure
                                                typeInput="text"
                                                labelInput={t('contractingRegistrationDataView.input.state.label')}
                                                valueInput={stateCity}
                                                handleChangeInput={(e) => onChangeState(e)}
                                                tooltipShow={false}
                                                informationIcon={false}
                                                inputActive={true}
                                            />
                                            {errorState && (
                                                <span className="hint-message-error">
                                                    {t('contractingRegistrationDataView.input.state.error')}
                                                </span>
                                            )}
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <InputHLPure
                                                typeInput="text"
                                                labelInput={t('contractingRegistrationDataView.input.cp.label')}
                                                valueInput={cp}
                                                handleChangeInput={(e) => onChangeCP(e)}
                                                tooltipShow={false}
                                                informationIcon={false}
                                                inputActive={true}
                                            />
                                            {errorCp && (
                                                <span className="hint-message-error">
                                                    {t('contractingRegistrationDataView.input.cp.error')}
                                                </span>
                                            )}
                                        </div>
                                        <div className="contractingRegistrationDataView-inputs-padding-bottom">
                                            <DropDownBtnHLPure
                                                labelDropDown={t('contractingRegistrationDataView.dropdown.label.countries')}
                                                optionsDropDown={countriesList}
                                                valueItem={"country"}
                                                nameOption={"country"}
                                                optionsValue={valueDropCountry}
                                                onDropDownChange={(e) => handleDropDownChageCountries(e)}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <div className="contractingRegistrationDataView-container-btns">
                                <div className="contractingRegistrationDataView-container-btn-seconday">
                                    <ButtonHLPure
                                        nameBtn={back}
                                        primary={false}
                                        onClickBtn={(event) => handleExit(event)}
                                    />
                                </div>
                                <ButtonHLPure
                                    nameBtn={next}
                                    primary={true}
                                    onClickBtn={(event) => handleSaveInfo(event)}
                                />
                            </div>
                        </>
                    )
            }
        </div>
    );
};

export default ContractingRegistrationDataView;